(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lw-site-core"] && !Shopify.designMode) return;
  try {
    if (!window.lwCoreInitialized) {
    window.lwCoreInitialized = true;

    const initAnnouncements = () => {
      document.querySelectorAll('[data-lw-announcement][data-rotate="true"]').forEach((root) => {
        if (root.dataset.lwReady === 'true') return;
        const items = Array.from(root.querySelectorAll('.lw-announce__item'));
        if (items.length < 2) return;
        root.dataset.lwReady = 'true';
        let index = 0;
        window.setInterval(() => {
          items[index].classList.remove('is-active');
          index = (index + 1) % items.length;
          items[index].classList.add('is-active');
        }, 3600);
      });
    };

    const updateTrackState = (track, prev, next) => {
      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      prev.disabled = track.scrollLeft <= 6;
      next.disabled = track.scrollLeft >= maxScroll - 6;
    };

    const initTracks = () => {
      document.querySelectorAll('[data-lw-track-shell]').forEach((shell) => {
        if (shell.dataset.lwReady === 'true') return;
        const track = shell.querySelector('[data-lw-track]');
        const prev = shell.querySelector('[data-lw-prev]');
        const next = shell.querySelector('[data-lw-next]');
        if (!track || !prev || !next) return;
        shell.dataset.lwReady = 'true';

        const move = (direction) => {
          const amount = Math.max(track.clientWidth * 0.88, 260) * direction;
          track.scrollBy({ left: amount, behavior: 'smooth' });
        };

        prev.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', () => updateTrackState(track, prev, next), { passive: true });
        window.addEventListener('resize', () => updateTrackState(track, prev, next));
        updateTrackState(track, prev, next);
      });
    };

    const initTabs = () => {
      document.querySelectorAll('[data-lw-tabs]').forEach((root) => {
        if (root.dataset.lwReady === 'true') return;
        const buttons = Array.from(root.querySelectorAll('[data-lw-tab-button]'));
        const panels = Array.from(root.querySelectorAll('[data-lw-tab-panel]'));
        if (!buttons.length || !panels.length) return;
        root.dataset.lwReady = 'true';

        const activate = (target) => {
          buttons.forEach((button) => {
            const active = button.dataset.lwTabButton === target;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach((panel) => {
            panel.classList.toggle('is-active', panel.dataset.lwTabPanel === target);
          });
          const label = root.querySelector('[data-lw-tab-label]');
          const currentButton = buttons.find((button) => button.dataset.lwTabButton === target);
          if (label && currentButton) {
            label.textContent = currentButton.dataset.lwTabLabel || currentButton.textContent || '';
          }
          const activePanel = panels.find((panel) => panel.dataset.lwTabPanel === target);
          activePanel?.querySelector('[data-lw-track]')?.dispatchEvent(new Event('scroll'));
        };

        buttons.forEach((button) => {
          button.addEventListener('click', () => activate(button.dataset.lwTabButton));
        });

        activate(buttons[0].dataset.lwTabButton);
      });
    };

    const initMegaTabs = () => {
      document.querySelectorAll('[data-lw-mega-tabs]').forEach((root) => {
        if (root.dataset.lwMegaReady === 'true') return;
        const buttons = Array.from(root.querySelectorAll('[data-lw-mega-tab-button]'));
        const panels = Array.from(root.querySelectorAll('[data-lw-mega-tab-panel]'));
        if (!buttons.length || !panels.length) return;
        root.dataset.lwMegaReady = 'true';

        const activate = (target) => {
          buttons.forEach((button) => {
            const active = button.dataset.lwMegaTabButton === target;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach((panel) => {
            panel.classList.toggle('is-active', panel.dataset.lwMegaTabPanel === target);
          });
        };

        buttons.forEach((button) => {
          button.addEventListener('mouseenter', () => activate(button.dataset.lwMegaTabButton));
          button.addEventListener('focus', () => activate(button.dataset.lwMegaTabButton));
          button.addEventListener('click', () => activate(button.dataset.lwMegaTabButton));
        });

        activate(buttons[0].dataset.lwMegaTabButton);
      });
    };

    const initDrawer = () => {
      document.querySelectorAll('[data-lw-drawer-root]').forEach((root) => {
        if (root.dataset.lwReady === 'true') return;
        const drawer = root.querySelector('.lw-header__drawer');
        const openButton = root.querySelector('[data-lw-drawer-open]');
        const closeButton = root.querySelector('[data-lw-drawer-close]');
        const backdrop = root.querySelector('[data-lw-drawer-backdrop]');
        if (!drawer || !openButton || !closeButton || !backdrop) return;
        root.dataset.lwReady = 'true';

        const open = () => {
          drawer.hidden = false;
          window.requestAnimationFrame(() => drawer.classList.add('is-open'));
          document.body.style.overflow = 'hidden';
        };

        const close = () => {
          drawer.classList.remove('is-open');
          window.setTimeout(() => {
            if (!drawer.classList.contains('is-open')) drawer.hidden = true;
          }, 220);
          document.body.style.overflow = '';
        };

        openButton.addEventListener('click', open);
        closeButton.addEventListener('click', close);
        backdrop.addEventListener('click', close);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !drawer.hidden) close();
        });
      });
    };

    const initFooterAccordions = () => {
      document.querySelectorAll('[data-lw-footer-group]').forEach((group) => {
        if (group.dataset.lwReady === 'true') return;
        const toggle = group.querySelector('[data-lw-footer-toggle]');
        if (!toggle) return;
        group.dataset.lwReady = 'true';
        toggle.addEventListener('click', () => {
          if (window.innerWidth > 989) return;
          group.classList.toggle('is-open');
        });
      });
    };

    const boot = () => {
      initAnnouncements();
      initTracks();
      initTabs();
      initMegaTabs();
      initDrawer();
      initFooterAccordions();
    };

    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  }
  } catch(e) { console.error(e); }
})();

})();
